let currentPath: string | null = null;
let currentQuery = '';

export const getCurrentPath = (): string | null => currentPath;

export const getCurrentQuery = (): string => currentQuery;

export function setCurrentLocation(path: string | null, query = ''): void {
  currentPath = path;
  currentQuery = query;
}
